/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EquipmentModeSwitchOperationStatuses } from './equipment-mode-switch-operation-statuses';


export interface EquipmentModeSwitchOperationResponse { 
    id?: string;
    status?: EquipmentModeSwitchOperationStatuses;
    requestedModeId?: number;
    requestedRawModeValue?: string | null;
    requestedAtUtc?: string;
    commandDispatchedAtUtc?: string | null;
    deviceRequestSentAtUtc?: string | null;
    telemetryConfirmedAtUtc?: string | null;
    failedAtUtc?: string | null;
    staleAtUtc?: string | null;
    failureReason?: string | null;
    isOverdue?: boolean;
}



